import { render, staticRenderFns } from "./GuildChannel.vue?vue&type=template&id=6dbf4a60&scoped=true&"
import script from "./GuildChannel.vue?vue&type=script&lang=js&"
export * from "./GuildChannel.vue?vue&type=script&lang=js&"
import style0 from "./GuildChannel.vue?vue&type=style&index=0&id=6dbf4a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf4a60",
  null
  
)

export default component.exports